import { css } from 'linaria';

export const axisPoint = css`
  && {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 80px;
    width: 80px;
    padding: 16px;
    border: 1px solid var(--control-secondary);
    border-radius: var(--rounding-m);
    cursor: pointer;
    margin-right: 8px;
  }
`;

export const axisPointPreview = css`
  width: 48px;
  height: 48px;
  border-radius: 10px;
`;

export const activeAxisPoint = css`
  && {
    border: 2px solid var(--control-primary);
  }
`;

export const inactiveAxisPoint = css`
  && {
    background: repeating-linear-gradient(
      -45deg,
      var(--background-secondary) 6px,
      var(--background-secondary) 12px,
      var(--control-minor) 13px,
      var(--control-minor) 14px
    );
    pointer-events: none;

    p {
      color: #b0b0b0;
    }
  }
`;
